import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormContainerTextfield } from '@/components/common/Form/Container/Textfield';
import { FormLabel } from '@/components/common/Form/Label';
import { FormLayoutFieldset } from '@/components/common/Form/Layout/Fieldset';
import { FormLayoutUnitDivider } from '@/components/common/Form/Layout/UnitDivider';
import { FormRadioButtonItem } from '@/components/common/Form/RadioButtonItem';
import { ToggleLabelButton } from '@/components/common/Form/ToggleLabelButton';
import { TitleSectionTitle } from '@/components/common/Title/SectionTitle';
import { PLACEHOLDER } from '@/definition/PLACEHOLDER';

type TSectionProps = {
  id?: string;
  original: {
    dependent_family?: number;
    partner?: boolean;
    duty_of_support?: boolean;
  };
};

export const ResumeFormSectionFamily = ({ id, original }: TSectionProps): React.ReactElement => {
  const methods = useFormContext();
  const family_check = methods.watch('family_check');

  return (
    <div id={id}>
      <TitleSectionTitle>
        <div className="flex items-center">
          <span className="mr-4">家族について</span>
        </div>
      </TitleSectionTitle>
      <div className="mbx-utils-stack-v--16">
        <ToggleLabelButton name="family_check" className="mb-16" />
        <FormLayoutFieldset>
          <FormLabel label="扶養家族数（配偶者を除く）" type="small"></FormLabel>
          <div className="flex mbx-utils-stack-h--8">
            {family_check ? (
              <FormContainerTextfield
                name="dependent_family"
                placeholder={PLACEHOLDER.dependent_family}
                type="number"
                min={0}
                className="w-150"
              />
            ) : (
              <div className="w-150 pointer-events-none opacity-40">
                <div className="mbx-formContainer--textfield-wrapper">
                  <input
                    type="number"
                    value={original.dependent_family ? original.dependent_family : ''}
                    placeholder={PLACEHOLDER.dependent_family}
                    readOnly
                    className="mbx-formContainer mbx-formContainer--textfield"
                  />
                </div>
              </div>
            )}
            <FormLayoutUnitDivider>人</FormLayoutUnitDivider>
          </div>
        </FormLayoutFieldset>
        <FormLayoutFieldset>
          <FormLabel label="配偶者" type="small"></FormLabel>
          <div className="mbx-utils-stack-h--54 flex w-150 mkt_mask_items">
            {family_check ? (
              <>
                <FormRadioButtonItem
                  label="有"
                  name="partner"
                  value="true"
                  className="flex-1"
                ></FormRadioButtonItem>
                <FormRadioButtonItem
                  label="無"
                  name="partner"
                  value="false"
                  className="flex-1"
                ></FormRadioButtonItem>
              </>
            ) : (
              <>
                <div className="flex-1 pointer-events-none opacity-40">
                  <label className="mbx-formRadio relative">
                    <input
                      type="radio"
                      value="true"
                      readOnly
                      checked={original.partner && original.partner == true ? true : false}
                    />
                    <span className="text-body_1 py-12 pl-32">有</span>
                  </label>
                </div>
                <div className="flex-1 pointer-events-none opacity-40">
                  <label className="mbx-formRadio relative">
                    <input
                      type="radio"
                      value="false"
                      readOnly
                      checked={original.partner && original.partner == true ? false : true}
                    />
                    <span className="text-body_1 py-12 pl-32">無</span>
                  </label>
                </div>
              </>
            )}
          </div>
        </FormLayoutFieldset>
        <FormLayoutFieldset>
          <FormLabel label="配偶者の扶養義務" type="small"></FormLabel>
          <div className="mbx-utils-stack-h--54 flex w-150 mkt_mask_items">
            {family_check ? (
              <>
                <FormRadioButtonItem
                  label="有"
                  name="duty_of_support"
                  value="true"
                  className="flex-1"
                ></FormRadioButtonItem>
                <FormRadioButtonItem
                  label="無"
                  name="duty_of_support"
                  value="false"
                  className="flex-1"
                ></FormRadioButtonItem>
              </>
            ) : (
              <>
                <div className="flex-1 pointer-events-none opacity-40">
                  <label className="mbx-formRadio relative">
                    <input
                      type="radio"
                      value="true"
                      readOnly
                      checked={
                        original.duty_of_support && original.duty_of_support == true ? true : false
                      }
                    />
                    <span className="text-body_1 py-12 pl-32">有</span>
                  </label>
                </div>
                <div className="flex-1 pointer-events-none opacity-40">
                  <label className="mbx-formRadio relative">
                    <input
                      type="radio"
                      value="false"
                      readOnly
                      checked={
                        original.duty_of_support && original.duty_of_support == true ? false : true
                      }
                    />
                    <span className="text-body_1 py-12 pl-32">無</span>
                  </label>
                </div>
              </>
            )}
          </div>
        </FormLayoutFieldset>
      </div>
    </div>
  );
};
